function DataEx1(){
     

    return(
        <div className="div">
          <h1>Forum voor Democratie en PvdA springen er uit als het gaat om gender targeting . FvD focust zich het meest op mannen, PvdA op vrouwen. </h1>
        </div>
    )
}

export default DataEx1
